/**
 * Organization member roles.
 * Matches memberRoles in packages/db/src/schema/auth.ts
 */
export type OrganizationRole =
  // Legados (modelo genérico de orgs).
  | "admin"
  | "member"
  | "owner"
  | "viewer"
  // Academia (Space Academy — capa de organización).
  | "org_admin"
  | "campus_admin"
  | "teacher"
  | "staff"
  | "student"
  | "guardian";

export const ORGANIZATION_ROLES: OrganizationRole[] = ["admin", "member", "owner", "viewer"];

/**
 * Roles de academia OFERTABLES al invitar (owner se excluye: se asigna solo al
 * crear la org). El backend valida contra `auth::org_rbac::OrgRole`.
 */
export const ACADEMY_INVITE_ROLES: OrganizationRole[] = [
  "org_admin",
  "campus_admin",
  "teacher",
  "staff",
  "student",
  "guardian",
];

export function isOrganizationRole(role: string): role is OrganizationRole {
  return (ORGANIZATION_ROLES as readonly string[]).includes(role);
}
